import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const SubTaskIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.5 3.33398C3.5 3.05784 3.27614 2.83398 3 2.83398C2.72386 2.83398 2.5 3.05784 2.5 3.33398V12.2923C2.5 13.9492 3.84315 15.2923 5.5 15.2923H12.1294C12.364 16.5492 13.4667 17.5006 14.7917 17.5006C16.2874 17.5006 17.5 16.2881 17.5 14.7923C17.5 13.2965 16.2874 12.084 14.7917 12.084C13.4667 12.084 12.364 13.0354 12.1294 14.2923H5.5C4.39543 14.2923 3.5 13.3969 3.5 12.2923V7.37565H7.54606C7.78066 8.63255 8.88339 9.58396 10.2083 9.58396C11.7041 9.58396 12.9167 8.3714 12.9167 6.87563C12.9167 5.37986 11.7041 4.1673 10.2083 4.1673C8.88338 4.1673 7.78064 5.11873 7.54606 6.37565H3.5V3.33398ZM16.5 14.7923C16.5 15.7358 15.7352 16.5006 14.7917 16.5006C13.8482 16.5006 13.0833 15.7358 13.0833 14.7923C13.0833 13.8488 13.8482 13.084 14.7917 13.084C15.7352 13.084 16.5 13.8488 16.5 14.7923ZM10.2083 8.58396C11.1518 8.58396 11.9167 7.81912 11.9167 6.87563C11.9167 5.93214 11.1518 5.1673 10.2083 5.1673C9.26485 5.1673 8.5 5.93214 8.5 6.87563C8.5 7.81912 9.26485 8.58396 10.2083 8.58396Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

SubTaskIcon.propTypes = iconPropTypes;
SubTaskIcon.defaultProps = iconDefaultProps;
